import { Routes, Route } from "react-router-dom";
import CronLogListPage from "./list";
import CronLogViewPage from "./view";

function CronLogsPage() {
	return (
		<Routes>
			<Route index element={<CronLogListPage />} />
			<Route path="/:id" element={<CronLogViewPage />} />
		</Routes>
	);
}

export default CronLogsPage;
